import '.a{display:flex;}.ssr-plugin'
import '.c{align-items:center;}.ssr-plugin'
import '.ax{gap:0.5rem;}.ssr-plugin'
import '.dp{height:2.5rem;}.ssr-plugin'
import '.ck{justify-content:flex-end;}.ssr-plugin'
import '.c2{position:relative;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.b3{cursor:pointer;}.ssr-plugin'
import '.a8{width:100%;}.ssr-plugin'
import '.ee{padding-inline:1rem;}.ssr-plugin'
import '.n{justify-content:center;}.ssr-plugin'
import '.d3{position:sticky;}.ssr-plugin'
import '.c3{top:0;}.ssr-plugin'
import '.d4{z-index:10;}.ssr-plugin'
import '.ca{background:var(--shades-white);}.ssr-plugin'
import '.ao{max-width:77.5rem;}.ssr-plugin'
import '.a9{justify-content:space-between;}.ssr-plugin'
import { useCallback } from 'react'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Button } from '@app/components/core/button/Button'
import { styled } from 'inlines'
import fullLogo from '@app/assets/fullLogo.svg'
import { MegaMenu } from '../../megaMenu/MegaMenu.desktop'
import { HoverTabs } from '@app/components/core/tabs/HoverTabs'
import { useAuthModal } from '@app/util/hooks/useAuthModal'
import { TextLink } from '@app/components/core/link/TextLink'
import useTransform from '@app/util/useTransform'
import { pages } from '@app/util/links'
import { ProfileMenu } from '../blocks/ProfileMenu'
import { useLocation } from 'wouter'
import { authTabs } from '../../authentication/authTabs'
import { Image } from '@app/components/core/image/Image'
import { useTranslations } from '@i18n/useLanguage'

export type TopNavBarProps = {
  userName?: string
  avatar?: string
  isLoading?: boolean
}

const ACCOUNT_SLOT_WIDTH = '14rem'
const ACCOUNT_APPEAR_ANIMATION = 'nav-account-appear 220ms ease-out'

const AuthButtons = () => {
  const { showAuthModal } = useAuthModal()

  return (
    <div className="a c ax"
    >
      <Button
        variant="secondary"
        label="Log in"
        onClick={() => showAuthModal(authTabs.login)}
        style={{
          whiteSpace: 'nowrap',
        }}
      />
      <Button
        variant="primary"
        label="Meld je aan"
        onClick={() => showAuthModal(authTabs.signUp)}
        style={{
          whiteSpace: 'nowrap',
        }}
      />
    </div>
  )
}

export const TopNavBar = ({ userName, avatar, isLoading }: TopNavBarProps) => {
  const translations = useTranslations().app.nav
  const transformStyle = useTransform('center')
  const [, navigate] = useLocation()

  const renderAccountSection = useCallback(() => {
    if (isLoading) {
      return (
        <div className="dp"
          style={{
            width: ACCOUNT_SLOT_WIDTH,}}
        />
      )
    }
    return userName ? (
      <div className="a ck"
        style={{
          width: ACCOUNT_SLOT_WIDTH,
          animation: ACCOUNT_APPEAR_ANIMATION,
        }}
      >
        <ProfileMenu>
          <div className="c2 a b c b3"
          >
            <Avatar
              size="small"
              labelSource={userName}
              image={avatar}
              onClick={() => navigate(pages.dashboard)}
            />
          </div>
        </ProfileMenu>
      </div>
    ) : (
      <div className="a ck"
        style={{
          width: ACCOUNT_SLOT_WIDTH,
          animation: ACCOUNT_APPEAR_ANIMATION,
        }}
      >
        <AuthButtons />
      </div>
    )
  }, [isLoading, userName, avatar, navigate])

  return (
    <div className="a8 ee a n d3 c3 d4 ca"
    >
      <styled.nav className="ca a8 ao a a9 c"
        style={{
          ...transformStyle,
        }}
      >
        <TextLink
          to={pages.home}
          noHover={true}
          isBold={false}
          hasIcon={false}
          textStyle={{ lineHeight: 0 }}
        >
          <Image src={fullLogo} alt="Crowdbuilding Logo" />
        </TextLink>
        <HoverTabs.Group>
          <HoverTabs.Tab label={translations.find}>
            <MegaMenu variant={'find'} />
          </HoverTabs.Tab>
          <HoverTabs.Tab label={translations.start}>
            <MegaMenu variant={'start'} />
          </HoverTabs.Tab>
          <HoverTabs.Tab label={translations.learn}>
            <MegaMenu variant={'learn'} />
          </HoverTabs.Tab>
          <HoverTabs.Tab label={translations.aboutUs}>
            <MegaMenu variant={'aboutUs'} />
          </HoverTabs.Tab>
        </HoverTabs.Group>
        {renderAccountSection()}
      </styled.nav>
    </div>
  )
}
